import { Component, OnInit } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { NotificationService } from '@app/services/notification.service';
import gql from 'graphql-tag';


@Component({
  selector: 'app-embarcacion',
  templateUrl: './embarcacion.component.html',
  styleUrls: ['./embarcacion.component.css']
})
export class EmbarcacionComponent implements OnInit {

  displayedColumns: string[] = ['campo', 'valor'];
  embarcacionNic = null;
  embarcacion = null;
  loading = false;
  suscripcion: Subscription;
  listaInspecciones: any[] = [];
  listaCapacidades: any[] = [];
  razonSocial = null
  datafile: String;

  constructor(
       private actRoute: ActivatedRoute,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private router: Router
    ) {

  }

  ngOnInit(): void {
    this.suscripcion = this.actRoute.paramMap.subscribe(params => {
      this.embarcacionNic = params.get('nic');
      console.log(this.embarcacionNic);
      this.traerEmbarcacion();
    });
  }

  traerEmbarcacion() {
    this.loading = true;
    this.apollo
      .watchQuery<any>({
        query: gql`
        {
          obtenerEmbarcacionDetalle (
            embNic: "${this.embarcacionNic}"
            ) {
              nic
              nombre
              enZarpes
              enConvoys
              clasEmbar{
                cembNombre
              }
              tipoServicioCodigo
              patentes {
                patNumero
              }
              resoluciones{
                tvempCodPaTipvinemp
              }
              polizasVigentes
              propietarios{
                ppeTodoc
                pperNrodoc
          			rpPersona{
                  perTdoc
                  perNrodoc
                  rpPersjur{
                    pjurRazonSocial
                  }
                  rpPersnatur{
                    pnatPrimerApellido
                    pnatPrimerNombre
                  }
                  }
              }
              raInspectecs {
                itecFinVig
                itecCod
                einsNomPaEstainspe
                raLischintes {
                  moPaItem {
                    itemCod
                    itemNombre
                  }
                  lcheValor
                }
              }
            }
        }
      `,
      })
      .valueChanges.subscribe(({ data, errors, loading }) => {
          this.embarcacion = data.obtenerEmbarcacionDetalle;
          console.log(this.embarcacion);
          this.cargarDataAlFormulario();
          console.log(this.listaCapacidades);
          console.log(this.embarcacion.raInspectecs);
        this.loading = false;
      }, (err) => {
        this.notificationService.showNotification('Error', 'Embarcacion no encontrada', 'danger')
        this.router.navigate(['/embarcaciones']);
        console.log('embarcacion no existe');
      });
  }

  /* 
   obtenerCertificadoTradicion(embNic:"40110079" usuarioDoc:"C-79519352"){
    certificadoBase64
  }*/
  obtenerCertificadoBase64(){
    const myCert = this.embarcacionNic;
    this.apollo
      .watchQuery<any>({
        query: gql`
        {
          obtenerCertificadoTradicion(
            embNic: "${myCert}"
            ) {
              certificadoBase64
          }
        }
      `,
      })
      .valueChanges.subscribe(({data}) => {
        this.datafile = data.obtenerCertificadoTradicion.certificadoBase64;
        const linkSource = 'data:application/pdf;base64,' + this.datafile;
        const downloadLink = document.createElement("a");
        const fileName = 'certificado'+ myCert +'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      });
}

  // Función que abre la ventana del reporte en PDF
  openPdfDialog(): void {
    this.obtenerCertificadoBase64();

}
  cargarDataAlFormulario(){
 
  }
}
